var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ObiApp',[_c('router-view'),_c('notifications',{attrs:{"position":"top center","max":1,"width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }